import React from "react";
import { Image, Table, Tag, Popconfirm, Button } from "antd";
import { ColumnType } from "antd/es/table";
import { RiDeleteBin6Line } from "react-icons/ri";
import { FiEdit3 } from "react-icons/fi";
import { renderIcon, renderTableText } from "../../../../lib/utils";
import MyPagination from "../../../components/Pagination";
import { useNavigate } from "react-router-dom";
import { IBlogPayload } from "../../../../types/api/blog";

const DeleteIcon = renderIcon(RiDeleteBin6Line);
const EditIcon = renderIcon(FiEdit3);

interface BlogTableProps {
  data?: IBlogPayload[];
  handleDelete?: (id: string) => void;
  form?: any;
  handleEditClick?: (id: string) => void;
  loading?: boolean;
  DEFAULT_NUQS_CONFIG?: any;
  qData?: any;
  refetch?: any;
}

const BlogTable: React.FC<BlogTableProps> = ({
  data = [],
  loading = false,
  DEFAULT_NUQS_CONFIG,
  qData,
  refetch,
  handleEditClick,
  handleDelete,
}) => {
  const navigate = useNavigate();

  const columns: ColumnType<IBlogPayload>[] = [
    {
      title: "Title",
      dataIndex: "heading",
      key: "heading",
      render: (v) => renderTableText(v),
    },
    {
      title: "Thumbnail ",
      dataIndex: "picture",
      key: "picture",
      render: (v) => {
        return (
          <div className=" size-12 rounded-full overflow-hidden">
            <Image src={v} alt="image" className="w-full h-full object-cover" />
          </div>
        );
      },
    },
    {
              title: "Order",
              dataIndex: "order",
              key: "order",
              render : (v) => renderTableText(v)
            },
    
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status: boolean) => (
        <Tag color={status ? "green" : "red"} bordered>
          {status ? "Published" : "Draft"}
        </Tag>
      ),
    },

    {
      title: "Action",
      key: "action",
      align: "right",
      render: (_: any, row: any) => (
        <div className="flex items-center justify-end gap-2 md:gap-3 md:pr-3">
          <EditIcon
            className="cursor-pointer text-primary text-[18px] md:text-[20px]"
            onClick={() => handleEditClick?.(row?._id)}
          />
          <Popconfirm
            title="Are you sure to delete this row?"
            onConfirm={() => handleDelete?.(row?._id)}
            okText="Yes"
            cancelText="No"
          >
            <DeleteIcon className="cursor-pointer text-primary hover:text-red-600 text-[18px] md:text-[20px]" />
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div>
        <Table
          dataSource={data || []}
          columns={columns}
          rowKey={(item: any) => item?._id}
          pagination={false}
          size="middle"
          bordered={false}
          loading={loading}
          className="custom-table-class rounded-lg border border-gray-200 shadow-md"
          footer={() => (
            <MyPagination
              qData={qData}
              onChange={refetch}
              total={qData?.total}
              DEFAULT_NUQS_CONFIG={DEFAULT_NUQS_CONFIG}
            />
          )}
        />
      </div>
    </div>
  );
};

export default BlogTable;
